"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = require("styled-components");
var utils_1 = require("../../utils");
var ThemeContext = styled_components_1.ThemeContext; // Any as no types set for that styled-component.
exports.ThemeContext = ThemeContext;
ThemeContext.Extend = function (_a) {
    var children = _a.children, value = _a.value;
    return (React.createElement(ThemeContext.Consumer, null, function (theme) { return React.createElement(ThemeContext.Provider, { value: utils_1.deepMerge(theme, value) }, children); }));
};
ThemeContext.Extend.propTypes = {
    children: prop_types_1.default.node.isRequired,
    value: prop_types_1.default.shape({}).isRequired
};
//# sourceMappingURL=ThemeContext.js.map